import axios from 'axios'
import { API_ORIGIN } from '../../utils/constants/url'
import generalHeader from '../../utils/constants/generalHeader'

// Answers without a login: the token from the invitation email is the credential. Plain axios, as
// axiosInstance cancels every request made without a session token.
const getInvitationPreview = ({ orgId, invitationId, token }) =>
  axios
    .get(`${API_ORIGIN}/v1/orgs/${orgId}/invitations/${invitationId}/preview`, {
      params: { token },
      headers: generalHeader(),
    })
    .then((r) => r.data)

export default getInvitationPreview
